import React, { Component } from 'react'
import Link from './Link.js'
import PropTypes from 'prop-types'

import { API_BASE_URL_DEV, API_BASE_URL_PROD } from './../config.js'

const INTERVAL = 20000
const COLORS = [
  'yellow',
  'pink',
  'green',
  'orange',
  'yellow2',
  'blue',
  'brown',
  'green2',
  'red',
  'brown2',
  'orange2',
  'purple',
  'brown3',
  'green3',
  'green4',
  'grey',
  'grey2',
  'green5',
  'blue2',
  'brown4'
]

const menu = [
  {
    title: 'Theatertexte',
    category: 'texte',
    subEntries: []
  },
  {
    title: 'Daniela Janjic',
    category: 'dj',
    subEntries: []
  }
]

export default class Menu extends Component {
  constructor(props) {
    super(props)
    const x = Math.floor(Math.random() * COLORS.length)
    this.state = { index: x }
    this.tick = this.tick.bind(this)
  }

  componentDidMount() {
    this.interval = setInterval(this.tick, INTERVAL)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  tick() {
    this.setState({ index: (this.state.index + 1) % COLORS.length })
  }

  render() {
    return (
      <div
        id="menu"
        className={
          'menu menu--' +
          COLORS[this.state.index] +
          ' menu--' +
          this.props.category
        }
      >
        {menu.map(function(menuEntry, index) {
          return <MenuEntry menuEntry={menuEntry} key={index} {...this.props} />
        }, this)}
      </div>
    )
  }
}

class MenuEntry extends Component {
  constructor(props) {
    super(props)
    this.state = { hidden: true, subEntries: [] }
  }

  componentDidMount() {
    // ugly hack. :(
    if (this.props.menuEntry.category === 'dj') {
      this.setState(
        {
          subEntries: [
            { Slug: 'vita', Title: 'Vita' },
            { Slug: 'publikationen', Title: 'Publikationen' },
            { Slug: 'kontakt', Title: 'Kontakt' },
            { Slug: '', Title: 'Where is home?' }
          ]
        },
        () => {
          this.t1 = setTimeout(() => this.toggle(), 1000)
        }
      )
    } else if (this.props.menuEntry.category === 'texte') {
      const url =
        (process.env.NODE_ENV === 'development'
          ? API_BASE_URL_DEV
          : API_BASE_URL_PROD) + 'publications'

      fetch(url, {})
        .then(response => response.json())
        .then(json =>
          this.setState({ subEntries: json }, () => {
            this.t2 = setTimeout(() => this.toggle(), 2000)
          })
        )
    }
  }

  componentWillUnmount() {
    this.clearTimeouts()
  }

  clearTimeouts() {
    clearTimeout(this.t1)
    clearTimeout(this.t2)
  }

  toggle() {
    this.clearTimeouts()
    if (this.state.subEntries.length !== 0) {
      this.setState({ hidden: !this.state.hidden })
    } else {
      window.history.pushState(null, null, '/' + this.props.menuEntry.category)
      window.dispatchEvent(new window.PopStateEvent('popstate'))
    }
  }

  goHome() {
    window.history.pushState(null, null, '/')
    window.dispatchEvent(new window.PopStateEvent('popstate'))
  }

  render() {
    return (
      <div
        className={'menu-entry menu-entry--' + this.props.menuEntry.category}
      >
        <a className="menu-entry-main" onClick={this.toggle.bind(this)}>
          {this.props.menuEntry.title}
        </a>
        {this.state.subEntries.map(function(subEntry, index) {
          return (
            <Link
              onClick={
                window.innerWidth > 590 ? () => {} : this.toggle.bind(this)
              }
              className={
                'menu-entry-sub menu-entry-sub--' +
                subEntry.Slug +
                (this.state.hidden ? ' menu-entry-sub--hidden' : '') +
                ((this.props.slug === subEntry.Slug &&
                  this.props.slug !== '') ||
                this.props.category === subEntry.Slug
                  ? ' menu-entry-sub--selected'
                  : '')
              }
              key={index}
              to={
                '/' +
                (this.props.menuEntry.category !== 'dj'
                  ? this.props.menuEntry.category + '/'
                  : '') +
                subEntry.Slug
              }
            >
              {subEntry.Title}
            </Link>
          )
        }, this)}
      </div>
    )
  }
}

MenuEntry.propTypes = {
  menuEntry: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/front/components/menu.js